import { map } from 'lodash';
import { settings } from '~/config';

import { GET_SEARCH_BASIC } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * SiteImage Reducer
 * @param {*} state
 * @param {*} action
 */
export default function searchBasic(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SEARCH_BASIC}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_SEARCH_BASIC}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${GET_SEARCH_BASIC}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
